module.exports = __webpack_public_path__ + "img/u1.9e35da08.png";